function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.115 12l2.525 2.524a.374.374 0 010 .53l-.586.586a.374.374 0 01-.53 0L12 13.116 9.475 15.64a.374.374 0 01-.529 0l-.586-.587a.374.374 0 010-.53L10.884 12 8.36 9.475a.374.374 0 010-.529l.586-.586a.374.374 0 01.53 0L12 10.884l2.524-2.524a.374.374 0 01.53 0l.586.586a.374.374 0 010 .53L13.115 12z",
  fill: "currentColor",
  fillRule: "nonzero"
});

var SvgStatusFailedIcon = function SvgStatusFailedIcon(props) {
  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgStatusFailedIcon;